<template>
  <!-- 产品配置 -->
  <div class="configProduct">
    <div class="search-box ban3" :class="{ 'open': searchMore }">
      <div class="input-item">
        <span class="label">产品名称</span>
        <Input v-model="searchParams.productName" placeholder="请输入产品名称" clearable />
      </div>
      <div class="input-item">
        <span class="label">产品编码</span>
        <Input v-model="searchParams.productCode" placeholder="请输入产品编码" clearable />
      </div>
      <div class="input-item">
        <span class="label">保险公司</span>
        <Select v-model="searchParams.companyCode" transfer placeholder="请选择保司" clearable filterable>
          <Option v-for="(item, index) in companyList" :value="item.code" :key="index">{{ item.name }}</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">长短险</span>
        <Select v-model="searchParams.productType" transfer placeholder="请选择上架状态" clearable>
          <Option value="1">长险</Option>
          <Option value="2">短险</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">上架状态</span>
        <Select v-model="searchParams.publishStatus" transfer placeholder="请选择上架状态" clearable>
          <Option value="1">已下架</Option>
          <Option value="2">已上架</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">销售状态</span>
        <Select v-model="searchParams.salesStatus" transfer placeholder="请选择销售状态" clearable>
          <Option value="1">停售</Option>
          <Option value="2">在售</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">供应商类型</span>
        <RadioGroup v-model="searchParams.supplierType" @on-change="changeOriginSupplierType">
          <Radio label="">全部</Radio>
          <Radio label="1">保司</Radio>
          <Radio label="2">通道</Radio>
        </RadioGroup>
      </div>
      <div v-if="searchParams.supplierType" class="input-item">
        <span class="label">供应商</span>
        <Select v-model="searchParams.supplierIds" multiple :max-tag-count="4" clearable filterable transfer>
          <Option v-for="item in supplierList" :key="item.value" :value="item.value">{{ item.label }}</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">业务类别</span>
        <Select v-model="searchParams.sellType" clearable transfer>
          <Option value="1">网销</Option>
          <Option value="3">经代</Option>
        </Select>
      </div>
      <div class="btn-item">
        <Button class="reset-btn" v-if="searchMore" @click="searchMore = false">收起<Icon type="ios-arrow-up" /></Button>
        <div class="close-open" v-else @click="searchMore = true">展开<Icon type="ios-arrow-down" /></div>
        <Button type="primary" @click="searchAjax">查询</Button>
      </div>
    </div>
    <div class="content">
      <Tabs v-model="tabActive" @on-click="searchAjax(true)" v-if="detail.status == 0 || detail.status == 1 || isAdd == 1">
        <TabPane label="全部" name="0"></TabPane>
        <TabPane :label="item.name" :name="item.id" v-for="(item, i) in themeList" :key="i"></TabPane>
      </Tabs>

      <!-- 表格 -->
      <div class="table-box">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData" @on-selection-change="selectRow">
          <template slot-scope="{ row }" slot="action">
            <div class="detail">
              <div
                v-if="selectArr.filter(v => row.productCode == v.productCode).length"
                @click="$refs.gradeConfig.open(selectArr[selectArr.findIndex(v => row.productCode == v.productCode)], {...detail, mode}, id)"
              >
                费用配置
              </div>
              <div v-else style="color: #dcdee2">费用配置</div>
            </div>
          </template>
          <template slot-scope="{ row }" slot="productName">
            <Tooltip class="productName" :content="row.productName">
              <span @click="showEdit(row)">{{ row.productName }}</span>
            </Tooltip>
          </template>
        </Table>
        <Page
          v-if="status == 0 || status == 1 || !status || compontntType == 'configModal'"
          :total="total"
          :current.sync="pageNum"
          :page-size="pageSize"
          show-total
          @on-change="changePage"
          style="text-align: center; margin-top: 20px"
        />
      </div>
    </div>
    <!-- 费用配置 -->
    <gradeConfig :compontntType='compontntType' ref="gradeConfig" />
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import gradeConfig from './gradeConfig.vue';
import _ from 'lodash';
export default {
  components: { gradeConfig },
  mixins: [pageTool, common],
  props: ['isAdd', 'status', 'id', 'compontntType', 'mode', 'type'],
  data() {
    return {
      companyList: [],
      detail: {},
      isAll: false,
      tabActive: '0', //激活的tab
      supplierList: [], //供应商
      selectArr: [], //表格选择的数据
      themeList: [],
      allCodes: [], //所有的code
      columns: [
        {
          type: 'selection',
          width: 100,
          align: 'center'
        },
        {
          title: '产品编码',
          key: 'productCode',
          align: 'center',
          width: 100
        },
        {
          title: '产品名称',
          key: 'productName',
          align: 'center',
          slot: 'productName',
          width: '400'
        },
        {
          title: '保险公司',
          key: 'companyName',
          align: 'center'
        },
        {
          title: '供应商',
          key: 'supplierName',
          align: 'center'
        },
        {
          title: '业务类别',
          key: 'sellType',
          align: 'center',
          render(h, params) {
            if (params.row.sellType.includes('1')) {
              return <Tag color="blue">网销</Tag>;
            } else if (params.row.sellType.includes('3')) {
              return <Tag color="blue">经代</Tag>;
            }
          }
        },
        {
          title: '上架状态',
          slot: 'publishStatus',
          align: 'center',
          render(h, params) {
            if (params.row.publishStatus == 2) {
              return <Tag color="blue">上架</Tag>;
            } else {
              return <Tag color="red">下架</Tag>;
            }
          }
        },
        {
          title: '销售状态',
          slot: 'salesStatus',
          align: 'center',
          render(h, params) {
            if (params.row.salesStatus == 2) {
              return <Tag color="blue">在售</Tag>;
            } else {
              return <Tag color="red">停售</Tag>;
            }
          }
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: '110'
        }
      ],
      addProduct: []
    };
  },

  methods: {
    changeOriginSupplierType(value) {
      this.searchParams.supplierIds = [];
      if (!value) {
        this.supplierList = [];
        return;
      }
      this.$http({
        url: value == 1 ? '/buz/insuranceCompany/read/list' : '/buz/insuranceChannel/read/list',
        type: 'POST',
        data: {}
      }).then(res => {
        if (value) {
          this.supplierList = res.data.map(i => {
            return {
              value: i.id,
              label: i.name
            };
          });
        } else {
          this.supplierList = [];
        }
      });
    },
    // 查询签约保司
    queryInsuranceCompanyList() {
      this.$http({
        url: '/buz/insuranceCompany/read/list',
        type: 'POST',
        data: {
          companyType: '1'
        }
      }).then(res => {
        this.companyList = res.data;
      });
    },
    getThemeList(params) {
      delete params.themeId;
      this.$http({
        url: '/buz/merchantActivity/queryAllTheme',
        type: 'POST',
        data: {
          ...params
        }
      }).then(res => {
        this.themeList = res.data;
      });
    },
    async ok(selectAll) {
      // 梯度
      if (this.detail.mode == 2) {
        if (this.isAll || selectAll) {
          //全选时需将产品添加进selectArr中
          const { data } = await this.getAllList(this.allCodes);
          const arr = data.data.records || [];
          //去重处理，不能覆盖之前已经配置了的数据
          arr.map(code => {
            if (this.selectArr.filter(v => code.productCode == v.productCode)?.length) {
            } else {
              this.selectArr.push(code);
            }
          });
          return this.selectArr;
        } else {
          return this.selectArr;
        }
      } else {
        return this.selectArr;
      }
    },
    // 获取列表参数
    setListParams(params) {
      params.themeId = this.tabActive;
      params.activityProductType = this.detail.productType || '1';
      if (this.detail.activityId || this.id) {
        params.activityId = this.detail.activityId || this.id;
      }
    },
    searchAjax(reset) {
      if (this.status != 0 && this.status != 1) {
        this.isAll = false; //全选
      }
      this.listLoading = true;
      this.pageNum = 1;
      // 切换tabs分类
      const params = JSON.parse(JSON.stringify(this.searchParams));
      if (reset !== true && this.status != 0 && this.status != 1 && this.isAdd == '0') {
        this.tabActive = '0';
        this.setListParams(params);
      }
      this.getThemeList(params);
      clearTimeout(this.timer);
      this.timer = setTimeout(_ => {
        const id = this.id ? this.id : this.detail.activityId
        if (this.compontntType == 'configModal') {
          if (this.status == '-1') {
            // 奖励配置 - 已结束
            this.getSaveProduct(id);
          } else {
            // 奖励配置 - 进行中
            this.getSaveProduct(id);
          }
        } else {
          if (this.isAdd == 1) {
            // 新增
            this.getAllProducts();
          } else {
            // 编辑
            this.getSaveProduct(id);
            this.getAllProducts();
          }
        }
        // if (this.status != 0 && this.isAdd != '1') {
        //   this.getSaveProduct(id);
        // } else if (this.isAdd == 1) {
        //   this.getAllProducts();
        // } else {
        //   this.getList();
        // }
      }, 500);
    },
    listCallback(res) {
      this.addProduct = res.data.addProduct;
      res.data?.data?.records.forEach(item => {
        this.selectArr.forEach(item2 => {
          if (item.productCode == item2.productCode) {
            item._checked = true;
          }
        });
        if (this.isAll) {
          item._checked = true;
          item._disabled = true;
        }
        // 活动状态已结束与进行中禁用
        if (this.detail.status == '-1') {
          item._disabled = true;
        }
      });
      this.allCodes = res.data?.allProductCode;
      this.$nextTick(() => {
        this.total = res.data?.data?.total;
        this.tableData = res.data?.data?.records;
      });
    },
    // 选中某个
    selectRow(curSelectArr) {
      const codes = curSelectArr.map(item => item.productCode); //当前页勾选的
      const selectCodes = this.selectArr.map(item => item.productCode); //已经添加的数据
      this.tableData.forEach(item => {
        if (codes.includes(item.productCode) && !selectCodes.includes(item.productCode)) {
          //未添加已勾选的数据时添加数据
          this.selectArr.push(item);
          selectCodes.push(item.productCode);
        } else if (!codes.includes(item.productCode) && selectCodes.includes(item.productCode)) {
          //添加了未勾选的数据时删除
          this.selectArr.splice(selectCodes.indexOf(item.productCode), 1);
          selectCodes.splice(selectCodes.indexOf(item.productCode), 1);
        }
      });
    },
    showEdit(row = {}) {
      this.openPageTabTags('/productResource/productManager/productDetail', {
        id: row.productId,
        code: row.productCode,
        isCopy: row.isCopy,
        timeStr: new Date().getTime()
      });
    },
    //获取已保存的产品
    getSaveProduct(activityId) {
      if((this.status != '0' && this.status != '1' && this.compontntType != 'configModal') || (this.type == 2 && this.mode == 2)) return;
      this.$http({
        url: '/buz/merchantActivity/queryProductList',
        type: 'POST',
        data: {
          activityId,
          pageNo: this.pageNum,
          pageSize: this.pageSize,
          ...this.searchParams
        }
      }).then(res => {
        res.data.forEach(item => {
          item._checked = true;
          item._disabled = true;
        });
        this.tableData = res.data;
        this.selectArr = res.data;
        this.listLoading = false;
        this.total = res.total;
      });
    },
    changePage(num) {
      this.pageNum = num;
      if(this.compontntType == 'configModal') {
        this.getSaveProduct(this.id ? this.id : this.detail.activityId);
      }else{
        this.pageNum = num;
        this.getList();
      }      
    },
    // 获取所有产品
    getAllProducts: _.debounce(function () {
      const params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      this.getThemeList(params);
      this.initListAjax('/buz/merchantActivity/queryAddProductList');
    }, 200),
    init(id) {
      this.pageNum = 1;
      this.selectArr = [];
      this.isAll = false;
      this.detail.activityId = id;
      this.searchParams = {
        productName: '',
        productCode: '',
        companyCode: '',
        productType: '',
        publishStatus: '',
        salesStatus: '',
        supplierType: '',
        supplierIds: '',
        sellType: '',
      }
      // 未开始
      if (this.status != 0 && this.status != 1 && this.isAdd == '0') {
        this.getSaveProduct(id);
        return;
      }
      if (this.detail.activityId) {
        this.getSaveProduct(id);
      } else if ((this.status == '0' || this.status == '1') && this.isAdd == '0') {
        this.getSaveProduct(this.id);
      } else {
        this.getAllProducts();
      }
    }
  },
  mounted() {
    // 产品配置现有逻辑
    // 1.初始化 调取getAllProducts查所有产品
    // 2.如果是有已保存的产品 调取getSaveProduct方法并存到selectArr中,此时表格会勾选中对应的产品
    // 3.点击费用配置会将selectArr中的那条产品数据传到gradeConfig
    // 4.配置完后selectArr中的那条产品数据就会有对应配置的值
    // 5.提交时用的selectArr的数据，包含了选中的产品和档次信息
    const vm = this;
    if (this.isAdd || this.status == '0' || this.status == 1) {
      this.init();
    }
    this.queryInsuranceCompanyList();
    // 清空配置
    this.$bus.$on('resetList', data => {
      vm.detail = data;
      vm.selectArr = [];
      if (data.status == 0 || data.status == 1) {
        vm.getAllProducts();
      }
    });
  }
};
</script>
<style lang="scss" scoped>
.table-box {
  margin-top: 20px;
}
.configProduct {
  .search-box {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
    height: 45px;
    overflow: hidden;
    &.open {
      height: auto;
    }

    .input-item {
      width: 33.33%;
      min-width: 240px;
      display: flex;
      margin-bottom: 15px;
      align-items: center;
      .label {
        font-size: 13px;
      }

      /deep/ .ivu-input {
        font-size: 13px;
      }

      /deep/ .ivu-select-selected-value {
        font-size: 13px;
      }
    }
    @media screen and (max-width: 1330px) {
      .input-item {
        width: 50%;
      }
    }

    .btn-item {
      display: flex;
      margin-left: auto;
      .reset-btn {
        background-color: #fff;
        color: #236dff;
        border: 1px solid #236dff;
        margin-left: 10px;
      }
      .close-open {
        width: 80px;
        height: 30px;
        border-radius: 2px;
        background-color: #fff;
        color: #236dff;
        border: 1px solid #236dff;
        margin-left: 10px;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
  }

  .btn3 {
    padding-right: 100px;
  }
  .search-wrap {
    margin: 10px 0;
    .ivu-btn {
      position: absolute;
      right: 30px;
    }
    .ivu-select-selection {
      border-radius: 2px;
      height: 30px;
      justify-content: space-between;
    }
  }
  .ivu-tabs-nav-container {
    font-size: 16px;

    .ivu-tabs-tab {
      padding: 10px 24px;
    }
  }
  /deep/.productName {
    width: 100%;
    > .ivu-tooltip-rel {
      width: 100%;
      > span {
        width: 100%;
        display: inline-block;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        vertical-align: middle;
        cursor: pointer;
        color: #236dff;
        text-decoration: underline;
      }
    }
  }
}
</style>
